var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-item rounded-10 w-100 p-3 shadow-sm"},[_c('div',{staticClass:"d-flex align-items-center mr-3",staticStyle:{"min-width":"'32px'"}},[_vm._t("title")],2),_c('div',{staticClass:"flex-fill d-flex justify-content-center align-items-center"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }